module.exports = "https://static.wmbcdn.com/uniweb/images/42ed5c26453af981cd8bd183e3ff3776.svg";